export default __webpack_public_path__ + "static/media/gallery_02.b03f58b0.jpg";